import axios from 'axios';
import { getApiBaseUrl } from '../apiBase';

const AGENT_URL = 'http://127.0.0.1:6789';

function api() {
    const token = localStorage.getItem('token');
    return axios.create({
        baseURL: getApiBaseUrl(),
        headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
}

export async function fetchAgentStatus() {
    try {
        const res = await fetch(`${AGENT_URL}/status`, { signal: AbortSignal.timeout(2000) });
        if (!res.ok) return { alive: false };
        return await res.json();
    } catch {
        return { alive: false };
    }
}

export async function fetchAgentPorts() {
    const res = await fetch(`${AGENT_URL}/devices/ports`, { signal: AbortSignal.timeout(3000) });
    if (!res.ok) throw new Error('Agent ports failed');
    return res.json();
}

export async function fetchAgentDevicesAll() {
    const res = await fetch(`${AGENT_URL}/devices/all`, { signal: AbortSignal.timeout(8000) });
    if (!res.ok) throw new Error('Agent devices failed');
    return res.json();
}

export async function fetchAgentScanners() {
    const res = await fetch(`${AGENT_URL}/devices/scanners`, { signal: AbortSignal.timeout(5000) });
    if (!res.ok) throw new Error('Scanners failed');
    return res.json();
}

export async function testAgentScanner(deviceId) {
    const res = await fetch(`${AGENT_URL}/devices/test-scanner`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ deviceId }),
        signal: AbortSignal.timeout(15000)
    });
    return res.json();
}

export function startBarcodeListen() {
    return fetch(`${AGENT_URL}/barcode/listen/start`, { signal: AbortSignal.timeout(3000) });
}

export const AGENT_WS_URL = 'ws://127.0.0.1:6789/barcode/ws';

export function archiveKkm(id, orgId, reason) {
    return api().post(`/kkm/${id}/archive`, { reason }, { params: { orgId } });
}

export function restoreKkm(id, orgId) {
    return api().post(`/kkm/${id}/restore`, null, { params: { orgId } });
}

export async function scanAgentNetwork(subnet = '192.168.1') {
    const res = await fetch(`${AGENT_URL}/devices/network-devices?subnet=${encodeURIComponent(subnet)}`, {
        signal: AbortSignal.timeout(60000)
    });
    if (!res.ok) throw new Error('Scan failed');
    return res.json();
}

export async function testAgentKkm(body) {
    const res = await fetch(`${AGENT_URL}/kkm/test`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        signal: AbortSignal.timeout(10000)
    });
    return res.json();
}

export function listOrganizations() {
    return api().get('/organizations');
}

export function getOrganization(id) {
    return api().get(`/organizations/${id}`);
}

export function createOrganization(dto) {
    return api().post('/organizations', dto);
}

export function updateOrganization(id, dto) {
    return api().put(`/organizations/${id}`, dto);
}

export function verifyInn(orgId, inn) {
    return api().get(`/organizations/${orgId}/verify-inn`, { params: { inn } });
}

export function linkOrgVenue(orgId, venueId, dto) {
    return api().post(`/organizations/${orgId}/venues/${venueId}`, dto);
}

export function getVenueEquipment(venueId) {
    return api().get(`/venues/${venueId}/equipment`);
}

export function listKkm(orgId) {
    return api().get(`/organizations/${orgId}/kkm`);
}

export function createKkm(orgId, dto) {
    return api().post(`/organizations/${orgId}/kkm`, dto);
}

export function updateKkm(orgId, id, dto) {
    return api().put(`/organizations/${orgId}/kkm/${id}`, dto);
}

export function testKkm(orgId, id) {
    return api().post(`/organizations/${orgId}/kkm/${id}/test`);
}

export function getFnStatus(orgId, id) {
    return api().get(`/organizations/${orgId}/kkm/${id}/fn-status`);
}

export function listAcquiring(orgId) {
    return api().get(`/organizations/${orgId}/acquiring`);
}

export function createAcquiring(orgId, dto) {
    return api().post(`/organizations/${orgId}/acquiring`, dto);
}

export function updateAcquiring(orgId, id, dto) {
    return api().put(`/organizations/${orgId}/acquiring/${id}`, dto);
}

export function testAcquiring(orgId, id) {
    return api().post(`/organizations/${orgId}/acquiring/${id}/test`);
}

export function listCashierKkms(venueId) {
    return api().get('/cashier/kkms', { params: venueId ? { venueId } : {} });
}

export function cashierCheckout(body) {
    return api().post('/cashier/checkout', body);
}
